<template>
    <v-container>
    <v-row class="mt-5">
      <v-col cols="12" md="6">
        <v-btn-toggle v-model="displayType">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-cards-variant</v-icon>
              </v-btn>
            </template>
            <span>Card</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-table</v-icon>
              </v-btn>
            </template>
            <span>Table</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-btn-toggle class="ml-2" v-model="timeRange">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-speedometer-slow</v-icon>
              </v-btn>
            </template>
            <span>Short Range</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-speedometer-medium</v-icon>
              </v-btn>
            </template>
            <span>Medium Range</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-speedometer</v-icon>
              </v-btn>
            </template>
            <span>Long Range</span>
          </v-tooltip>
        </v-btn-toggle>
      </v-col>
      <v-col cols="12" md="6">
        <v-slider
          v-model="limit"
          label="Item count"
          max="50"
          min="5"
          thumb-color="primary"
          thumb-label="always"
          @change="updateLimit"
        ></v-slider>
      </v-col>
    </v-row>
  
    <v-tabs centered v-model="type">
      <v-tab>Tracks</v-tab>
      <v-tab>Artists</v-tab>
      <v-tab>Album</v-tab>
      <v-tab-item>
        <template v-if="topTracks && topTracks.length > 0">
          <Card :items="topTracks" v-if="displayType === 0" :type="type"/> 
          <TrackTable :items="topTracks" v-else />
        </template>
        <template v-else>
          <h3 class="text-center ma-5"> Nothing to display here :( </h3>
        </template>
      </v-tab-item>
      <v-tab-item>
        <template v-if="topArtists && topArtists.length > 0">
          <Card :items="topArtists" v-if="displayType === 0" :type="type"/> 
          <ArtistTable :items="topArtists" v-else />
        </template>
        <template v-else>
          <h3 class="text-center ma-5"> Nothing to display here :( </h3>
        </template>
      </v-tab-item>
      <v-tab-item>
        <template v-if="topAlbums && topAlbums.length > 0">
          <Card :items="topAlbums" v-if="displayType === 0" :type="type"/> 
          <AlbumTable :items="topAlbums" v-else />
        </template>
        <template v-else>
          <h3 class="text-center ma-5"> Nothing to display here :( </h3>
        </template>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TrackTable from '@/components/TrackTable.vue'
import Card from '@/components/Card.vue'
import ArtistTable from '@/components/ArtistTable.vue'
import AlbumTable from '@/components/AlbumTable.vue'

export default {
  name: 'Spotify',
  components: {
    TrackTable,
    Card,
    ArtistTable,
    AlbumTable
  },
  data() {
    const timeRanges = ['short_term', 'medium_term', 'long_term'];
    const rankingTypes = ['tracks', 'artists', 'albums'];
    return {
      rankingTypes,
      timeRanges,
      displayType: 0,
      timeRange: 0,
      type: 0,
      limit: 5
    };
  },
  watch: {
    timeRange(val) {
      this.GetTopItems({
        ranking_type: this.rankingTypes[this.type], 
        limit: this.limit, 
        time_range: this.timeRanges[val]
      })
    },
    type(val) {
      this.GetTopItems({
        ranking_type: this.rankingTypes[val], 
        limit: this.limit, 
        time_range: this.timeRanges[this.timeRange]
      })
    }
  },
  created() {
    if(this.token.length === 0) this.$router.push('/');
    this.GetTopItems({ranking_type: this.rankingTypes[0], limit: this.limit, time_range: this.timeRanges[0]});
  },
  methods: {
    ...mapActions('SpotifyModule', ['GetTopItems']),
    updateLimit(val) {
      this.GetTopItems({
        ranking_type: this.rankingTypes[this.type], 
        limit: val, 
        time_range: this.timeRanges[this.timeRange]
      })
    }
  },
  computed: mapState('SpotifyModule', {
    token: state => state.token,
    topTracks: state => state.topTracks,
    topArtists: state => state.topArtists,
    topAlbums: state => state.topAlbums
  })
}
</script>